import { constructEnum } from '@/lib/enum';

export default constructEnum('DropdownMenuWidth', {
  SMALL: 160,
  MEDIUM: 320,
  LARGE: 400
});
